module.exports = __webpack_public_path__ + "static/media/arrowLeft.9ab15f62.svg";